import React, { useState, useRef, useEffect, useContext } from "react";
import { Authenticator } from "./Authenticator";
import { Email } from "./Email";
import { RecoveryCode } from "./RecoveryCode";
import styles from "./styles/Profile.module.css";
import { useAuth } from "../../../Context/AuthContext";
import ChangeEmail from "./ChangeEmail";
import { EnablePerm } from "./EnablePerm";
import ChangePwd from "./ChangePwd";
import { UserData } from "../../../Context/DataContext";
import { formatEmail } from "../../../Utils/formatEmail";
import { isValidEmail } from "../../../Utils/isValidEmail";
import { DeleteAccount } from "./DeleteAccount";
import { useLocation } from "react-router-dom";
import Confirmation from "../../Confirmation/Confirmation";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";
import "./styles/phone.css";
import { Button, Form, Input } from "antd";
import config from "../../../config";
import PhoneInput from "react-phone-input-2";
import { floatMessage } from "../../../Utils/floatMessage";
const base_url = config.base_url;
function Profile({ scrollToRecovery = false }) {
  const ref = useRef(null);
  const [customerPhoneNumber, setCustomerPhonenumber] = useState(null);
  const [customerPhoneNumberError, setCustomerPhonenumberError] =
    useState(false);
  const userData = UserData();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.Profile
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.Profile);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  useEffect(() => {
    if (scrollToRecovery) {
      ref?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      userData.setMyAccount(1);
    }
  }, []);
  const hasCustomerPhoneNumber =
    userData.UserData.customer_phone_number !== null;

  const [modal, setModal] = useState(null);
  const [recoveryModal, setRecoveryModal] = useState(null);
  const [form] = Form.useForm();
  const auth = useAuth();
  console.log("auth");
  console.log(auth);

  const [changeEmail, setChangeEmail] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showSuccessPass, setShowSuccessPass] = useState(false);
  const [changePwd, setChangePwd] = useState(false);
  const [changeName, setChangeName] = useState(false);
  const [showSuccessName, setShowSuccessName] = useState(false);
  const [loadChangeNameButton, setLoadChangeNameButton] = useState(false);
  const [checkedSubscribe, setCheckedSubscribe] = useState(
    userData?.CustomerUser?.newsletter
  );
  const recovery_key_copied = Boolean(userData.CustomerUser.code_copied);
  useEffect(() => {
    if (changeName) {
      form.setFieldsValue({
        customer_full_name: userData.UserData.customer_full_name.trim(),
      });
    }
  }, [changeName]);
  const showSuccessMessage = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const showSuccessPassMessage = () => {
    setShowSuccessPass(true);
    setTimeout(() => {
      setShowSuccessPass(false);
    }, 5000);
  };
  const handleNewsLetterSubscription = () => {
    userData.setCustomerUser({
      ...userData.CustomerUser,
      newsletter: !userData.CustomerUser?.newsletter,
    });
    setCheckedSubscribe(!checkedSubscribe);
  };
  const scrollToMethods = () => {
    let innerHeight_Half = window.innerHeight >> 1;
    let elementRect = document
      .getElementById("methods")
      .getBoundingClientRect();

    window.scrollBy(elementRect.left >> 1, elementRect.top - innerHeight_Half);
  };
  const changeCustomerName = async (values) => {
    setLoadChangeNameButton(true);
    await fetch(base_url + "user/edit/name", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `customer_full_name=${values.customer_full_name}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200 && res.statusText === "OK") {
          const name = values.customer_full_name.split(" ");
          const customer_name = name[0];
          const customer_last_name = name[name.length - 1];
          userData.setUserData({
            ...userData.UserData,
            customer_full_name: values.customer_full_name,
            customer_name,
            customer_last_name,
          });

          setTimeout(() => {
            setShowSuccessName(false);
          }, 3000);
        }
        setShowSuccessName(true);
        setChangeName(false);
        setLoadChangeNameButton(false);
      })
      .catch((err) => {
        setLoadChangeNameButton(false);
      });
  };
  const { pathname, hash, key } = useLocation();
  const handleChangePhoneNumber = () => {
    if (!customerPhoneNumber) {
      setCustomerPhonenumberError(true);
      return;
    }
    userData.edit("customer_phone_number", customerPhoneNumber);
    setCustomerPhonenumberError(false);
    floatMessage(dublicatedcontent?.saved);
  };
  const handleDisablePhoneNumber = () => {
    userData.edit("customer_phone_number", null);

    setCustomerPhonenumber(null);
  };
  useEffect(() => {
    // const Weglot = document.createElement("script")
    // Weglot.src = "https://cdn.weglot.com/weglot.min.js"
    // document.body.appendChild(Weglot)
    // Weglot.onload = () => {
    //     console.log('Script is loaded')
    //     window.Weglot.initialize({
    //         api_key: 'wg_fe59e91dbf7c41abd8908f1b88215ff17',
    //     });
    // }
    if (!scrollToRecovery) {
      if (hash === "") {
        window.scrollTo(0, 0);
      }
    } else {
      setTimeout(() => {
        const id = hash.replace("#", "");

        if (id === "recovery") {
          setRecoveryModal(
            <Confirmation
              close_button="none"
              confirm_button={dublicatedcontent?.confirm}
              title={""}
              text={content.profileText1}
              onClose={() => {
                setRecoveryModal(null);
                scrollToMethods();
              }}
              OnConfirm={() => {
                setRecoveryModal(null);
                scrollToMethods();
              }}
            />
          );
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change

  return (
    <div className={styles.main}>
      <div className={styles.title_main}>
        {dublicatedcontent.dublicatedText77}
      </div>
      <div className={styles.rect} />
      <div className={styles.auth_div}>
        <div className={styles.cred_div}>
          <div className={styles.cred}>
            <div className={styles.input_title}>
              {dublicatedcontent.dublicatedText74}
            </div>
            {!showSuccess && (
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                {formatEmail(auth.email)}{" "}
                {!changeEmail && (
                  <p
                    disabled={userData.isFreezed}
                    onClick={() => {
                      setChangeEmail(!changeEmail);
                      setChangePwd(false);
                      setChangeName(false);
                    }}
                    style={{
                      color: "rgba(0, 145, 234, 1)",
                      fontWeight: "500",
                      fontSize: "14px",
                      margin: "0",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    {dublicatedcontent.dublicatedText267}
                  </p>
                )}
              </div>
            )}
            {showSuccess && (
              <div className={styles.success_message}>
                {content.profileText4}
              </div>
            )}
          </div>
        </div>
        {changeEmail ? (
          <ChangeEmail
            onClose={(newEmail) => {
              setChangeEmail(false);
              if (newEmail) {
                if (isValidEmail(newEmail)) {
                  auth.setEmail(newEmail);
                  showSuccessMessage();
                }
              }
            }}
          />
        ) : null}

        <div className={styles.cred_div}>
          <div
            onClick={() => {
              return;
            }}
            className={styles.cred}
          >
            <div className={styles.input_title}>{content?.profileText27}</div>

            <div
              style={{
                display: "flex",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  margin: "0",
                  transform: "translateY(5px)",
                }}
              >
                *******
              </p>
              {!changePwd && (
                <p
                  disabled={userData.isFreezed}
                  onClick={() => {
                    setChangePwd(!changePwd);
                    setChangeEmail(false);
                    setChangeName(false);
                  }}
                  style={{
                    color: "rgba(0, 145, 234, 1)",
                    fontWeight: "500",
                    fontSize: "14px",
                    margin: "0",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  {dublicatedcontent.dublicatedText267}
                </p>
              )}
            </div>
            {showSuccessPass && (
              <div className={styles.success_message}>
                {content.profileText6}
              </div>
            )}
          </div>
        </div>
        {changePwd ? (
          <ChangePwd
            onClose={(newPassword) => {
              setChangePwd(false);
              if (newPassword) {
                showSuccessPassMessage();
              }
            }}
          />
        ) : null}
        <div className={styles.cred_div}>
          <div
            className={styles.cred}
            style={{
              width: "100%",
            }}
          >
            {" "}
            <div className={styles.input_title}>
              {dublicatedcontent.dublicatedText268}
            </div>
            {!changeName && (
              <div>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      textTransform: "capitalize",
                    }}
                  >
                    {userData.UserData.customer_full_name}
                  </p>{" "}
                  <p
                    disabled={userData.isFreezed}
                    onClick={() => {
                      setChangeName(!changeName);
                      setChangePwd(false);
                      setChangeEmail(false);
                    }}
                    style={{
                      color: "rgba(0, 145, 234, 1)",
                      fontWeight: "500",
                      fontSize: "14px",
                      margin: "0",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    {dublicatedcontent.dublicatedText267}
                  </p>
                </div>
                {showSuccessName && (
                  <div className={styles.success_message}>
                    {dublicatedcontent.dublicatedText266}
                  </div>
                )}
              </div>
            )}
            {changeName && (
              <div className={styles.changeNameContainer}>
                <Form
                  onFinish={changeCustomerName}
                  form={form}
                  className={styles.nameForm}
                >
                  <Form.Item
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name={"customer_full_name"}
                  >
                    <Input
                      className="formInput"
                      style={{
                        textTransform: "capitalize",
                      }}
                    />
                  </Form.Item>

                  <div className={styles.buttons_div}>
                    <Button
                      disabled={loadChangeNameButton}
                      style={{
                        height: "100%",
                      }}
                      onClick={() => {
                        setChangeName(false);
                      }}
                      className={styles.cancel_button}
                    >
                      {dublicatedcontent.dublicatedText184}
                    </Button>
                    <Button
                      loading={loadChangeNameButton}
                      style={{
                        height: "100%",
                      }}
                      onClick={() => {
                        form.submit();
                      }}
                      className={styles.save_button}
                    >
                      {dublicatedcontent.dublicatedText151}
                    </Button>
                  </div>
                </Form>
                <div className={styles.name_hint}>
                  <div className={styles.hint_title}>
                    {" "}
                    {dublicatedcontent.dublicatedText264}
                  </div>
                  <div className={styles.hint_description}>
                    {dublicatedcontent.dublicatedText265}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.checkbox_field}>
          <div
            onClick={(e) => {
              handleNewsLetterSubscription();
            }}
            className={`${styles.checkbox} ${
              checkedSubscribe ? styles.checked : styles.not_checked
            }`}
          />
          <div className={styles.option}>
            {content.profileText8}
            <div className={styles.promo_text}>
              <span>{content.profileText9pt1}</span>
              <span>{content.profileText9pt2}</span>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={styles.rect} />
      <div className={styles.phonenumberContainer}>
        <div className={styles.titleWrapper}>
          <p
            className={styles.title}
            style={{
              margin: "0",
            }}
          >
            {content.profileText31}
          </p>
          {hasCustomerPhoneNumber && (
            <Button
              onClick={() => {
                handleDisablePhoneNumber();
              }}
              className={styles.disablePhonenumberButton}
            >
              {content.profileText32}
            </Button>
          )}
        </div>
        <p className={styles.phonenumberBodyText}>{content.profileText33}</p>
        <p className={styles.phonenumberLabel}>{content.profileText34}</p>
        <div
          className={`${styles.phoneNumberInputWrapper} customerPhoneNumber`}
        >
          <div
            style={{
              width: "256px",
            }}
          >
            <PhoneInput
              inputClass={styles.legalPhoneInput}
              isValid={(value, country) => {
                const countryCodeLength = country.countryCode?.length;
                const y = value.slice(countryCodeLength);
                if (y?.length === 0) {
                  setCustomerPhonenumber(null);
                  return;
                }
                setCustomerPhonenumberError(false);
                setCustomerPhonenumber(value);
              }}
              country={
                !userData.UserData.customer_phone_number
                  ? websiteCurrentLang?.label === "fr"
                    ? "fr"
                    : "us"
                  : undefined
              }
              placeholder="Phone number"
              value={
                userData.UserData.customer_phone_number
                  ? userData.UserData.customer_phone_number
                  : websiteCurrentLang?.label === "fr"
                  ? "33"
                  : "1"
              }
            />
          </div>

          {!hasCustomerPhoneNumber && (
            <div
              style={{
                position: "relative",
              }}
            >
              <Button
                onClick={() => {
                  handleChangePhoneNumber();
                }}
                className={styles.phonenumberButton}
              >
                {content.profileText35}
              </Button>
              {customerPhoneNumberError && (
                <div
                  className={styles.error_message}
                  style={{
                    bottom: "-20px",
                    left: "12px",
                  }}
                >
                  {content.profileText36}
                </div>
              )}
            </div>
          )}
          {hasCustomerPhoneNumber && (
            <div
              style={{
                position: "relative",
              }}
            >
              <p
                onClick={() => {
                  handleChangePhoneNumber();
                }}
                className={styles.changePhoneNumber}
              >
                {content.profileText37}
              </p>
              {customerPhoneNumberError && (
                <div
                  className={styles.error_message}
                  style={{
                    bottom: "-5px",
                    left: "5px",
                  }}
                >
                  {content.profileText36}
                </div>
              )}
            </div>
          )}
        </div>
      </div> */}
      <div className={styles.rect} />
      <div className={styles.title}>{content.profileText10}</div>
      <div className={styles.subtitle_red}>{content.profileText11}</div>
      <div ref={ref} className={styles.warningtext}>
        {content.profileText12}
      </div>
      <div className={styles.view_container}>
        <button
          disabled={userData.isFreezed}
          onClick={() => {
            if (auth.MFApermissions) {
              setModal(<RecoveryCode OnClose={() => setModal(null)} />);
            } else {
              setModal(
                <EnablePerm
                  OnClose={() => setModal(null)}
                  OnConfirm={() =>
                    setModal(<RecoveryCode OnClose={() => setModal(null)} />)
                  }
                />
              );
            }
          }}
          className={styles.view_recovery_key}
        >
          {content.profileText13}
        </button>
        {!recovery_key_copied && (
          <div className={styles.recovery_text}>{content.profileText14}</div>
        )}
      </div>

      <div
        className={`${
          recovery_key_copied && !userData.isFreezed
            ? ""
            : styles.providers_disabled
        }`}
      >
        <div className={styles.title}>{content.profileText28}</div>
        <div className={styles.providers} id="methods">
          <div className={styles.provider}>
            <div className={styles.authenticator} />
            <div className={styles.center}>
              <div className={styles.subtitle}>
                {content.profileText15}
                {userData.CustomerUser.authenticator === "true" && (
                  <span className={styles.provider_enabled}>
                    {content?.profileText20}
                    {userData.CustomerUser.mfa.toLowerCase() ===
                      "authenticator" && (
                      <span> - {content.profileText21}</span>
                    )}{" "}
                  </span>
                )}
              </div>
              <div className={styles.mfa_description}>
                {content.profileText16}
              </div>
            </div>
            <div
              onClick={() => {
                auth.MFApermissions
                  ? setModal(<Authenticator OnClose={() => setModal(null)} />)
                  : setModal(
                      <EnablePerm
                        OnClose={() => setModal(null)}
                        OnConfirm={() =>
                          setModal(
                            <Authenticator OnClose={() => setModal(null)} />
                          )
                        }
                      />
                    );
              }}
              className={`${
                recovery_key_copied ? styles.manage_button : styles.disabled_btn
              }`}
            >
              {userData.CustomerUser.authenticator === "true"
                ? content.profileText29
                : content.profileText30}
            </div>
          </div>
          <div className={styles.rect} />
          <div className={styles.provider}>
            <div className={styles.yubikey} />
            <div className={styles.center}>
              <div className={styles.subtitle}>{content.profileText17}</div>
              <div className={styles.mfa_description}>
                {content.profileText18}
              </div>
            </div>
            <div className={styles.disabled_btn}>{content.profileText19}</div>
          </div>
          <div className={styles.rect} />
          <div className={styles.provider}>
            <div className={styles.email} />
            <div className={styles.center}>
              <div className={styles.subtitle}>
                Email
                {userData.CustomerUser.otp_email !== "false" && (
                  <span className={styles.provider_enabled}>
                    {content.profileText20}
                    {userData.CustomerUser.mfa === "email" && (
                      <span> - {content.profileText21}</span>
                    )}
                  </span>
                )}
              </div>
              <div className={styles.mfa_description}>
                {content.profileText22}
              </div>
            </div>
            <div className={styles.actions}>
              {userData.CustomerUser.otp_email !== "false" &&
              userData.CustomerUser.otp_secret !== "" ? (
                <div className={styles.disabled_btn}>
                  {content.profileText20}
                </div>
              ) : (
                <div
                  onClick={() => {
                    if (auth.MFApermissions) {
                      setModal(<Email OnClose={() => setModal(null)} />);
                    } else {
                      setModal(
                        <EnablePerm
                          OnClose={() => setModal(null)}
                          OnConfirm={() =>
                            setModal(<Email OnClose={() => setModal(null)} />)
                          }
                        />
                      );
                    }
                  }}
                  className={styles.manage_button}
                >
                  {dublicatedcontent.dublicatedText75}
                </div>
              )}
              <div className={styles.hint}>{content.profileText24}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.rect} />
      <div className={styles.delete_section}>
        <div className={styles.title}>
          {content.profileText25}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="22"
            fill="none"
          >
            <path
              fill="#B30606"
              d="M23.04 17.39 14.112 1.713a2.456 2.456 0 0 0-.892-.908 2.409 2.409 0 0 0-2.44 0c-.371.218-.679.531-.893.908L.96 17.39a2.494 2.494 0 0 0-.011 2.477c.214.377.522.69.893.907a2.4 2.4 0 0 0 1.22.329h17.875a2.4 2.4 0 0 0 1.221-.33c.371-.216.68-.53.893-.906a2.495 2.495 0 0 0-.011-2.477ZM11.187 8.726c0-.218.086-.428.238-.583a.806.806 0 0 1 1.15 0 .832.832 0 0 1 .237.583v4.126a.831.831 0 0 1-.238.583.806.806 0 0 1-1.149 0 .831.831 0 0 1-.238-.583V8.726ZM12 17.802c-.241 0-.477-.072-.677-.208-.2-.136-.357-.33-.45-.556a1.255 1.255 0 0 1 .265-1.348 1.201 1.201 0 0 1 1.328-.268c.223.093.413.252.547.455a1.251 1.251 0 0 1-.151 1.563 1.21 1.21 0 0 1-.862.362Z"
            />
            <path
              fill="#fff"
              d="M11.187 8.726c0-.218.086-.428.238-.583a.806.806 0 0 1 1.15 0 .832.832 0 0 1 .237.583v4.126a.831.831 0 0 1-.238.583.806.806 0 0 1-1.149 0 .831.831 0 0 1-.238-.583V8.726ZM12 17.802c-.241 0-.477-.072-.677-.208-.2-.136-.357-.33-.45-.556a1.255 1.255 0 0 1 .265-1.348 1.201 1.201 0 0 1 1.328-.268c.223.093.413.252.547.455a1.251 1.251 0 0 1-.151 1.563 1.21 1.21 0 0 1-.862.362Z"
            />
          </svg>
        </div>
        <div className={styles.delete_actions}>
          <div className={styles.delete_text}>{content.profileText26}</div>
        </div>
        <div
          className={styles.delete_button}
          onClick={(e) => {
            setModal(<DeleteAccount OnClose={() => setModal(null)} />);
          }}
        >
          {content.profileText25}
        </div>
      </div>
      <div style={{ position: "relative", zIndex: 10 }}></div>
      {modal}
      {recoveryModal}
    </div>
  );
}
export { Profile };
